
<template lang="pug">
q-layout.fit(view="hHh lpr fff")
  //- ヘッダ
  Header
  q-page-container.fit
    RoleGuard
      router-view
</template>

<script>
import RoleGuard from 'components/RoleGuard'
import Header from 'views/Header'

export default {
  components: {Header, RoleGuard},
}
</script>
